var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.readonly
      ? _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.operation.name,
                expression: "operation.name"
              }
            ],
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.operation,
                    "name",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
                function($event) {
                  return _vm.focus(0)
                }
              ]
            }
          },
          [
            _c("option", { attrs: { value: "" } }),
            _vm._v(" "),
            _c("option", { attrs: { value: "addTasks" } }, [
              _vm._v(_vm._s(_vm.i18n.addTasks))
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "completeTasks" } }, [
              _vm._v(_vm._s(_vm.i18n.completeTasks))
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "assignTasks" } }, [
              _vm._v(_vm._s(_vm.i18n.assignTasks))
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm.operation.name
      ? _c(
          "div",
          [
            _vm._l(_vm.operation.tasks, function(task, idx) {
              return _c(
                "div",
                {
                  key: task.id,
                  ref: "tasks",
                  refInFor: true,
                  staticClass: "tasks-item"
                },
                [
                  !_vm.readonly
                    ? _c("i", {
                        staticClass: "clickable icon-minus-sign text-red",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.remove(idx)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { display: "inline-block" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: task.name,
                            expression: "task.name"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: task.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(task, "name", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      ["addTasks", "assignTasks"].includes(_vm.operation.name)
                        ? _c("UsermTypeaheadVue", {
                            attrs: {
                              usermBaseUrl: _vm.usermBaseUrl,
                              i18n: _vm.i18n
                            },
                            model: {
                              value: task.assignee,
                              callback: function($$v) {
                                _vm.$set(task, "assignee", $$v)
                              },
                              expression: "task.assignee"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            }),
            _vm._v(" "),
            !_vm.readonly && _vm.operation.name
              ? _c("i", {
                  staticClass: "clickable icon-plus-sign text-green",
                  on: { click: _vm.add }
                })
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }